import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Steps } from 'src/app/utils/constants';

@Injectable({
	providedIn: 'root',
})
export class StepperService {
	private stepSubject: BehaviorSubject<number> = new BehaviorSubject(1);
	readonly stepActive$ = this.stepSubject.asObservable();

	nextStep() {
		const currentStep = this.stepSubject.value;
		if (currentStep < Steps.length) this.stepSubject.next(currentStep + 1);
	}

	previousStep(): void {
		const currentStep = this.stepSubject.value;
		if (currentStep > 1) this.stepSubject.next(currentStep - 1);
	}

	resetSteps(): void {
		this.stepSubject.next(1);
	}
}
